export default __webpack_public_path__ + "static/media/car.c5749d74.svg";